import { useState } from 'react'
import { Accordion } from 'react-accessible-accordion'
import { FaqAccordionItem } from '@/components/atomic/FaqAccordionItem'

import styles from './faqs.module.scss'

type FaqItem = {
  slug: string
  question: string
  answer: string
}

export type FaqsProps = {
  faqList: FaqItem[]
}

export const Faqs = ({ faqList }: FaqsProps) => {
  const [activeFaqs, setActiveFaqs] = useState([])

  return (
    <section className={styles['section-faqs']}>
      <div className={styles.grid}>
        <div className={styles.text}>
          <h2>your questions, answered</h2>
        </div>
        <div className={`${styles.faqs} make-model-faqs`}>
          <Accordion
            allowZeroExpanded={true}
            preExpanded={activeFaqs}
            onChange={value => setActiveFaqs(value)}>
            {faqList.length > 0 &&
              faqList.map(faq => (
                <FaqAccordionItem
                  item={faq}
                  key={faq.slug}
                  isActive={activeFaqs.includes(faq.slug)}
                />
              ))}
          </Accordion>
        </div>
      </div>
    </section>
  )
}
